import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Activate your account", -1)
const _hoisted_2 = { class: "govuk-body-l" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("An email has been sent to ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(". You need to click the activation link within the email in order to confirm your account and set your password.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("strong", null, _toDisplayString(_ctx.registrationData.email), 1),
      _hoisted_4
    ])
  ], 64))
}